import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { InboxOutlined } from '@mui/icons-material';

export interface EmptyStateProps {
  icon?: ReactNode;
  title?: string;
  description?: string;
  action?: ReactNode;
  compact?: boolean;
}

export default function EmptyState({
  icon,
  title = 'Sem resultados',
  description,
  action,
  compact = false,
}: EmptyStateProps) {
  return (
    <Box
      sx={{
        py: compact ? 4 : 6,
        px: 3,
        textAlign: 'center',
        color: 'text.secondary',
      }}
    >
      <Box
        sx={{
          mx: 'auto',
          mb: 2,
          width: compact ? 48 : 64,
          height: compact ? 48 : 64,
          borderRadius: '50%',
          backgroundColor: 'action.hover',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& svg': { fontSize: compact ? 24 : 32, color: 'text.secondary' },
        }}
      >
        {icon || <InboxOutlined />}
      </Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" sx={{ maxWidth: 420, mx: 'auto', mb: action ? 2 : 0 }}>
          {description}
        </Typography>
      )}
      {action && <Box>{action}</Box>}
    </Box>
  );
}
